// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

//otro

import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { CompanylinkedService } from "../../services/companylinked.service";
import { CompanyLinked } from "../../models/companylinked";
import swal from "sweetalert2";
import { NuevoCompany } from "../listcompany/listcompany.component";
import { FolderService } from "../../services/folder.service";
import { Folder } from "../../models/folder";
import { Methods } from "../../shared/methods";
import { DateAdapter } from "@angular/material/core";
import { LocationService } from "../../services/location.service";

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  selector: "app-listuser-cmp",
  templateUrl: "listuser.component.html",
  providers: [UserService, FolderService, CompanylinkedService],
})
export class ListuserComponent implements OnInit {
  name: string;
  animal: string;
  public mtds: Methods = new Methods();
  public activos = 1;
  public privilegio;
  sexos = [
    { value: "1", viewValue: "Hombre" },
    { value: "0", viewValue: "Mujer" },
  ];
  frequencies = [
    { value: "DAILY", viewValue: "Daily" },
    { value: "WEEKLY", viewValue: "Weekly" },
    { value: "MONTHLY", viewValue: "Monthly" },
    { value: "NEVER", viewValue: "Never" },
  ];
  public dataTable: DataTable;
  public pacientes: Array<User>;
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public loading;
  public filter = 0;
  public order = 0;
  public searchString;
  public user;
  public status_user;
  public companySelected;

  constructor(
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private titleService: Title,
    private _router: Router,
    private _folderService: FolderService,
    private _companylinkedService: CompanylinkedService,
    private _userService: UserService
  ) {
    this.titleService.setTitle("Vendors");
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    this.dataTable = {
      headerRow: [
        "ID",
        "Rep Name",
        "Company Name",
        "Title",
        "Name",
        "City",
        "State",
        "Actions",
      ],
      footerRow: [
        "ID",
        "Rep Name",
        "Company Name",
        "Title",
        "Name",
        "City",
        "State",
        "Actions",
      ],
      dataRows: [],
    };
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      this.getAllPacientes();
    }
  }

  cambiarActivos() {
    if (this.activos === 1) {
      this.activos = 0;
    } else {
      this.activos = 1;
    }

    this.getAllPacientes();
  }

  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    this._userService.deleteUser(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);
          // this.getAllPacientes();
          alert("Done");
        } else {
          alert("No se ha borrado el usuario");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  showSwal(type) {
    if (type === "success-message") {
      swal.fire({
        title: "Vendor successfully added!",
        text: "",
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "warning-message-and-confirmation") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to revert this!",

          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    } else if (type === "warning-message-and-cancel") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to recover this imaginary file!",

          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, keep it",

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .then(
          function () {
            swal.fire({
              title: "Deleted!",
              text: "Your imaginary file has been deleted.",
              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false,
            });
          },
          function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === "cancel") {
              swal.fire({
                title: "Cancelled",
                text: "Your imaginary file is safe :)",

                customClass: {
                  confirmButton: "btn btn-info",
                },
                buttonsStyling: false,
              });
            }
          }
        );
    } else if (type === "custom-html") {
      swal.fire({
        title: "HTML example",
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
        html:
          "You can use <b>bold text</b>, " +
          '<a href="http://github.com">links</a> ' +
          "and other HTML tags",
      });
    } else if (type === "auto-close") {
      swal
        .fire({
          title: "Auto close alert!",
          text: "I will close in 2 seconds.",
          timer: 2000,
          showConfirmButton: false,
        })
        .then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === "timer") {
              console.log("I was closed by the timer");
            }
          }
        );
    } else if (type === "input-field") {
      swal
        .fire({
          title: "Input something",
          html:
            '<div class="form-group">' +
            '<input id="input-field" type="text" class="form-control" />' +
            "</div>",
          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .then(function (result) {
          swal.fire({
            html:
              "You entered: <strong>" + $("#input-field").val() + "</strong>",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    }
  }

  openNuevoPaciente(): void {
    this.user = new User(
      1,
      "VENDOR",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      0,
      "",
      1,
      1,
      1,
      "",
      0,
      "",
      "",
      "",
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      "",
      "",
      "",
      ""
    );
    let dialogRef = this.dialog.open(NuevoPaciente, {
      width: "80%",
      data: { user: this.user, sexos: this.sexos },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this._userService.create(this.token, result).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
            if (response.code === 400) {
              alert(
                "It was not possible to add the user because: " + response.msg
              );
            } else {
              alert(
                "Error! Something went wrong, it was not possible to add the user"
              );
            }
          } else {
            let userid = {
              name: "mad",
              value: response.user.id,
            };

            if (response.hasfolder == null) {
              let folderNEw = new Folder(
                1,
                response.user.companyLinked.name,
                "",
                "",
                userid,
                "",
                0,
                0,
                1,
                0
              );
              console.log(folderNEw);
              this._folderService.create(this.token, folderNEw).subscribe(
                (response) => {
                  console.log(response);
                  this.status_user = response.status;

                  if (this.status_user != "success") {
                    // this.status_user = 'error';
                  } else {
                    //this.showSwal('success-message');
                    console.log("folder created");
                  }
                },
                (error) => {
                  console.log(<any>error);
                }
              );
            }

            this.showSwal("success-message");
            //this.animal = result;
            this.getAllPacientes();
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  public cargando = false;

  getAllPacientes() {
    this.cargando = true;
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      this.loading = "show";
      this._userService
        .getUsers(this.token, page, "ALL", this.activos)
        .subscribe(
          (response) => {
            this.pacientes = response.data;
            console.log(response);
            if (response.status == "success") {
              this.dataTable = {
                headerRow: [
                  "ID",
                  "Rep Name",
                  "Company Name",
                  "Title",
                  "Name",
                  "City",
                  "State",
                  "Actions",
                ],
                footerRow: [
                  "ID",
                  "Rep Name",
                  "Company Name",
                  "Title",
                  "Name",
                  "City",
                  "State",
                  "Actions",
                ],
                dataRows: [],
              };

              for (let element of response.data) {
                let nameCompany = "";
                if (element.companyLinked != null)
                  nameCompany = element.companyLinked.name;
                this.dataTable.dataRows.push([
                  element.id,
                  element.managedByString,
                  nameCompany,
                  element.ocupation,
                  element.name + " " + element.surname,
                  element.city,
                  element.colonia,
                  "",
                ]);
              }
              this.mtds.initTable("#datatables");
              this.loading = "hide";

              //total paginas
              this.pages = [];
              for (let i = 0; i < response.total_pages; i++) {
                this.pages.push(i);
              }

              //pagina anterior
              if (page >= 2) {
                this.pagePrev = page - 1;
              } else {
                this.pagePrev = page;
              }

              //pagina siguiente
              if (page < response.total_pages) {
                this.pageNext = page + 1;
              } else {
                this.pageNext = page;
              }
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
            this.cargando = false;
          },
          (error) => {
            console.log(<any>error);
            this.cargando = false;
          }
        );
    });
  }

  deleteFolderfirst(folder) {
    swal
      .fire({
        title: "",
        text:
          "Do you want to make this vendor " +
          (this.activos === 1 ? "inactive" : "active"),

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then(
        function (result) {
          if (result.value) {
            this._userService.deleteUser(this.token, folder).subscribe(
              (response) => {
                console.log(response);
                if (response.status === "success") {
                  this.getAllPacientes();
                  this.mtds.notifySuccess(
                    this.activos === 1
                      ? "Vendor status has been changed to customer"
                      : "Vendor status has been changed to active"
                  );
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );
  }
  /*
  ngAfterViewInit() {

    const table = $('#datatables').DataTable();

    // Edit record
    table.on('click', '.edit', function () {
      console.log("entramos");
      const $tr = $(this).closest('tr');

      const data = table.row($tr).data();
      alert('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
    });

    // Delete a record
    table.on('click', '.remove', function (e) {
      e.preventDefault();

      var txt;
      var r = confirm("Are you sure to delete this client?");
      if (r == true) {
        const $tr = $(this).closest('tr');
        const data = table.row($tr).data();

        table.row($tr).remove().draw();
        $("#borrarUser").val(data[0]);

        $("#borrarUser").trigger("click");
      } else {

      }


    });

    //Like record
    table.on('click', '.like', function () {
      console.log("like");

    });

    $('.card .material-datatables label').addClass('form-group');
  }*/
}

@Component({
  selector: "registro-paciente",
  templateUrl: "registro-paciente.html",
  providers: [UserService, CompanylinkedService, LocationService],
})
export class NuevoPaciente {
  public mtds: Methods = new Methods();
  public identity;
  public token;
  public user: User = new User();
  public status_user;
  public privilegio;
  public companySelected = "";
  public companies;
  public company;
  public companyLocations: any[] = [];

  sexos = [
    { value: "0", viewValue: "Female" },
    { value: "1", viewValue: "Male" },
    { value: "2", viewValue: "Other" },
  ];

  frequencies = [
    { value: "DAILY", viewValue: "Daily" },
    { value: "WEEKLY", viewValue: "Weekly" },
    { value: "MONTHLY", viewValue: "Monthly" },
    { value: "NEVER", viewValue: "Never" },
  ];

  cities = [
    { value: "paris-0", viewValue: "Paris" },
    { value: "miami-1", viewValue: "Miami" },
    { value: "bucharest-2", viewValue: "Bucharest" },
    { value: "new-york-3", viewValue: "New York" },
    { value: "london-4", viewValue: "London" },
    { value: "barcelona-5", viewValue: "Barcelona" },
    { value: "moscow-6", viewValue: "Moscow" },
  ];

  constructor(
    public dialogRef: MatDialogRef<NuevoPaciente>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _route: ActivatedRoute,
    private _locationService: LocationService,
    private _router: Router,
    public dialog: MatDialog
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    this.getAllCompanies();
  }

  getAllCompanies() {
    this._companylinkedService.getAllCompaniesLite(this.token, "all").subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.companies = response.data;
          console.log(this.companies);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    }
  }

  getCompanyLocations(company_id) {
    this._locationService
      .getLocationsByCompany(this.token, company_id)
      .subscribe((r) => {
        console.log(r);
        this.companyLocations = r.data;
      });
  }

  changeLocation() {
    let flat = false;
    if (this.data.user.locationId != null) {
      for (let loc of this.companyLocations) {
        if (this.data.user.locationId == loc.id) {
          console.log(loc);

          this.data.user.address = loc.address;
          this.data.user.address2 = loc.address2;
          this.data.user.country = loc.country;
          this.data.user.colonia = loc.colonia;
          this.data.user.city = loc.city;
          this.data.user.zipCode = loc.zipCode;
          flat = true;
          break;
        }
      }
    }

    if (!flat) {
      console.log(this.companyLinked);
      this.data.user.address = this.companyLinked.address;
      this.data.user.address2 = this.companyLinked.address2;
      this.data.user.country = this.companyLinked.country;
      this.data.user.colonia = this.companyLinked.colonia;
      this.data.user.city = this.companyLinked.city;
      this.data.user.zipCode = this.companyLinked.zipCode;
    }
  }

  openNuevoCompany(): void {
    this.company = new CompanyLinked(
      1,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      1,
      0,
      "",
      "",
      "",
      "",
      "",
      0,
      0,
      0,
      0
    );
    let dialogRef = this.dialog.open(NuevoCompany, {
      width: "80%",
      data: { user: this.company },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this._companylinkedService.create(this.token, result).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.getAllCompanies();
            this.companySelected = response.company.id;
            this.data.user.companyLinked = {
              id: this.companySelected,
            };
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  public companyLinked = null;

  changeCompany(e) {
    console.log("aqio");
    if (e.value) {
      this.companySelected = e.value;

      this.data.user.companyLinked = {
        id: this.companySelected,
      };
      console.log(this.data.user.companyLinked);
      this._companylinkedService
        .getCompany(this.token, this.companySelected)
        .subscribe(
          (response) => {
            console.log(response.data);
            this.data.user.address = response.data.address;
            this.data.user.address2 = response.data.address2;
            this.data.user.city = response.data.city;
            this.data.user.colonia = response.data.colonia;
            this.data.user.zipCode = response.data.zipCode;
            this.data.user.country = response.data.country;
            this.data.user.phone = response.data.phone;
            this.data.user.mobilePhone = response.data.mobilePhone;

            this.companyLinked = response.data;
            this.data.user.locationId = null;
            this.getCompanyLocations(this.companyLinked.id);
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
            console.log(<any>error);
          }
        );
    }
  }

  onSubmit() {
    console.log("enviamos");
    console.log(this.user);
    /* this._userService.create(this.token, this.user).subscribe(
         response => {
           console.log(response);
           this.status_user = response.status;
 
           if(this.status_user != 'success'){
             this.status_user = 'error';
           } else {
             this.user = response.data;
             //this._router.navigate(['/task', this.task.id]);
            this.dialogRef.close();
            return this.user;
           }
         },
         error => {
           console.log(<any>error);
         }
       );*/
  }

  onNoClick(): void {}
}
